import { ErrorPage } from '@/components/error-page';
import { LostArt } from '@/components/illustrations';

export function NotFoundPage() {
  return (
    <ErrorPage
      code={404}
      art={LostArt}
      title="Page not found"
      body="This page does not exist, or your role does not have a view for it."
    />
  );
}
